import { VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID } from "@/modules/global-state/globalEnv";

export const clientEnvGoogleAnalyticsMeasurementId = (): string | undefined => {
  return VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID || undefined;
};
